<template>
  <div class="">
    <consumptions> </consumptions>
  </div>
</template>

<script>
import Consumptions from "@/components/profile/emessage/consumptions/index.vue";
export default {
  props: {
    msg: String,
  },
  components: {
    Consumptions,
  },
  created() {},
};
</script>
